import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import { matchPath, useLocation } from 'react-router-dom';
import config from 'utils/config';
import { PEOPLE_ROUTES } from 'utils/routes';
import { useFetchUserMindsetSettings } from 'actions/userProfile';
import { useFetchUserHelixAccess } from 'actions/users';

// Domain-level checks — not user-specific

export var isMindsetEnabledInHub = !!config.mindsetAppUid;
export var isMindsetBankConfigured = !!config.mindsetBankUid;
export function useShowMindsetInPage() {
  var _useFetchUserMindsetS = useFetchUserMindsetSettings(),
    hasMindsetAgent = _useFetchUserMindsetS.hasMindsetAgent;
  var _useFetchUserHelixAcc = useFetchUserHelixAccess(),
    helixAccessData = _useFetchUserHelixAcc.data;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var isOnPeopleRoute = Object.values(PEOPLE_ROUTES).some(function (route) {
    return !!matchPath({
      path: route,
      end: false
    }, pathname);
  });
  return config.isTrialHub && hasMindsetAgent && (helixAccessData === null || helixAccessData === void 0 ? void 0 : helixAccessData.isHelixHub) && !isOnPeopleRoute;
}